import { useEffect, useRef, useState } from 'react';
import { useFeatureFlagsLoading } from '@harnessio/ff-react-client-sdk';

// FFContextProvider re-initializes whenever its target changes, but keeps serving the previous
// target's flags (with loading=false) until the new client is READY. Returns true only once the
// provider has completed a load for `targetKey` (JSON.stringify of the target passed to it).
export function useFlagsEvaluatedForTarget(targetKey: string): boolean {
  const loading = useFeatureFlagsLoading();
  const loadingTargetKey = useRef<string>();
  const [evaluatedTargetKey, setEvaluatedTargetKey] = useState<string>();

  useEffect(() => {
    if (loading) {
      loadingTargetKey.current = targetKey;
    } else if (loadingTargetKey.current === targetKey) {
      setEvaluatedTargetKey(targetKey);
    }
  }, [loading, targetKey]);

  return evaluatedTargetKey === targetKey;
}
